"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedbackSubmitUrl = exports.lead2gUpgradeUrl = exports.submitIdeasUrl = exports.quoteWizardUrl = exports.businessCaptureUrl = exports.leadUnsubUrl = exports.leadSubscriberUrl = exports.leadSubscribeUrl = exports.leadCaptureUrl = exports.contactFormUrl = exports.leadsUrl = void 0;
const config_1 = require("../config");
exports.leadsUrl = `${config_1.baseApiUrl}/leads/v1`;
exports.contactFormUrl = `${exports.leadsUrl}/contact`;
exports.leadCaptureUrl = `${exports.leadsUrl}/lead/capture`;
exports.leadSubscribeUrl = `${exports.leadsUrl}/lead/subscribe`;
exports.leadSubscriberUrl = `${exports.leadsUrl}/lead/subscriber`;
exports.leadUnsubUrl = `${exports.leadsUrl}/lead/unsubscribe`;
exports.businessCaptureUrl = `${exports.leadsUrl}/business/capture`;
exports.quoteWizardUrl = `${exports.leadsUrl}/quote-wizard`;
exports.submitIdeasUrl = `${exports.leadsUrl}/contact/idea`;
exports.lead2gUpgradeUrl = `${exports.leadsUrl}/lead/2gupgrade`;
exports.feedbackSubmitUrl = `${exports.leadsUrl}/feedback/email-feedback`;
//# sourceMappingURL=leadGen.js.map